<template>
  <div>
    <b-table :items="returnHistoryItem" :fields="returnHistoryFields" hover responsive show-empty
      emptyText="Chưa có đơn trả hàng nào" @row-clicked="showReturnDetail">
      <template #cell(totalPaidAmount)="data">
        <div>{{ (data.item.totalPaidAmount) ? formatMoneyNotUnit(divisionThousand(data.item.totalPaidAmount)) : 0 }}
        </div>
      </template>
      <template #cell(processorStatusText)="data">
        <base-tag :type="data.item.processorStatusDisplay.color">{{
            data.item.processorStatusDisplay.text
        }}</base-tag>
      </template>
      <template #cell(isReceivedItem)="data">
        <base-box-is-fill :isFilled="data.item.isReceivedItem" />
      </template>
      <template #cell(paymentStatus)="data">
        <base-payment-status :status="data.item.paymentStatus" />
      </template>
      <template #cell(soCreatedAt)="data">
        <span>
          {{ timeFormatDate(data.item.soCreatedAt) }}
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
import { OrdersService } from "@/services/nextshop/orders.service";
import { OrderReturnStatus } from "@/utils/mapping.js";

export default {
  data() {
    return {
      // return history
      returnHistoryFields: [
        {
          label: "Mã đơn trả",
          key: "orderNo",
          thStyle: { width: "4%" },
        },
        {
          label: "Trạng thái đơn",
          key: "processorStatusText",
          thStyle: { width: "4%", minWidth: "100px"},
        },
        {
          label: "SL trả",
          key: "quantity",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: { width: "4%" },
        },
        {
          label: "Phải hoàn",
          key: "totalPaidAmount",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: { width: "4%" },
        },
        {
          label: "Nhận hàng",
          key: "isReceivedItem",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: { width: "4%" },
        },
        {
          label: "Hoàn tiền",
          key: "paymentStatus",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: { width: "4%" },
        },
        {
          label: "Ngày tạo  ",
          key: "soCreatedAt",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: { width: "4%" },
        },
      ],
      returnHistoryItem: [],
    }
  },
  created() {
    console.log("return table");
    this.getReturnHistory()
  },
  methods: {
    async getReturnHistory() {
      const params = {
        "queryString": `{furtherInstructions.params.soOrderId} == '''${this.$route.params.id}'''`,
        "sortBy": "createdAt",
        "sortType": "DESC",
        "pageNum": "1",
        "pageSize": "200"
      }
      const response = await OrdersService.getListOrdersReturn(params);
      // console.log(333, this.itemId)
      if (response.success) {
        response.data.data.map(item => {
          if (item.furtherInstructions && item.furtherInstructions.length > 0) {
            const index = item.furtherInstructions.findIndex(item => item.key === "RETURN_ORDER")
            if (index != -1) {
              let quantiy = 0
              let totalPaidAmount = 0
              item.lineItem.forEach(e => {
                quantiy+= e.quantity
                totalPaidAmount+= e.totalAmount
              });
              const returnItem = {...item}
              if (item.processorStatus == "DRAFT") {
                item.processorStatus = "PROCESSING"
              }
              returnItem.orderNo = item.orderNo ? item.orderNo : ""
              returnItem.quantity = quantiy
              returnItem.processorStatusDisplay = item.processorStatus ? OrderReturnStatus(item.processorStatus) : null
              returnItem.processorStatusText = item.processorStatus ? OrderReturnStatus(item.processorStatus).text : ""


              const res = item.furtherInstructions[index].params ? item.furtherInstructions[index].params : null
              returnItem.totalPaidAmount = totalPaidAmount
              returnItem.isReceivedItem = res.isReceivedItem ? res.isReceivedItem : ""
              returnItem.paymentStatus = res.paymentStatus ? res.paymentStatus : ""
              returnItem.soCreatedAt = res.soCreatedAt ? res.soCreatedAt : ""

              this.returnHistoryItem.push(returnItem)
              // console.log(123, this.returnHistoryFields);
            }
          }
        })
      }
    },
    showReturnDetail(item) {
      this.$router.push({ path: `/orders-return/detail/${item.id}`})
    },
  }

}
</script>

<style>

</style>